import { AppHelper } from "../appHelper.js"
import { AppBaseProps, CommonApp, Context, Entity } from "../core/components/commonApp.js";
import { Helper } from "../core/util/helper.js";
import React from "react";

export default class StyleApp extends React.Component<StyleAppProps, any> {
    common = new AppHelper();
    constructor(props: StyleAppProps) {
        super(props);
        this.common.init(this);
    }

    handleFieldChange = (field, value, dataItem = null, isInit = false) => {
        if (!isInit)
            this.common.handleFieldChange(field, value, dataItem);
    }

    componentDidMount() {
        this.common.updateSheetTitle(this.props.title);
        this.common.updateBrowserTitle(this.props.title);
    }

    render() {
        const props = $.extend({}, this.props, this.common.getHandlersForProps(), { handleFieldChange: this.handleFieldChange });
        return <CommonApp {...props} title={this.props.title} />;
    }
};

export interface StyleAppProps extends AppBaseProps {
    entity: Entity;
    context: Context;
}


export class StyleHelper {
    public static getFontColor = (hexColor: string) => {
        const r = parseInt(hexColor.substring(1, 3), 16);
        const g = parseInt(hexColor.substring(3, 5), 16);
        const b = parseInt(hexColor.substring(5, 7), 16);
        const yiq = ((r * 299) + (g * 587) + (b * 114)) / 1000;
        return (yiq >= 128) ? 'black' : 'white';
    }

    public static hexToRgba = (hex): RGBA => {
        let result = /^#?([a-f\d]{2})([a-f\d]{2})([a-f\d]{2})([a-f\d]{0,2})$/i.exec(hex);
        return result ? {
            r: parseInt(result[1], 16),
            g: parseInt(result[2], 16),
            b: parseInt(result[3], 16),
            a: parseInt(result[4], 16)
        } : null;
    }

    public static rgbaToHex = (rgba: RGBA) => {
        const cleanValue = (value: number) => {
            if (isNaN(value))
                value = 0;
            return value < 0 ? 0 : value;
        }

        const decToHex = (dec: number) => {
            let result = dec.toString(16);
            if (result.length == 1) {
                result = "0" + result;
            }
            return result;
        }


        const r = cleanValue(rgba.r);
        const g = cleanValue(rgba.g);
        const b = cleanValue(rgba.b);
        const a = rgba.a;
        return `#${decToHex(r)}${decToHex(g)}${decToHex(b)}${(!Helper.isNumber(a) || isNaN(a) || a == 255) ? "" : decToHex(a)}`
    }
}

interface RGBA {
    r: number;
    g: number;
    b: number;
    a: number;
}